import { render } from "./FeedbackPopover.vue?vue&type=template&id=5a34bcb7&scoped=true"
import script from "./FeedbackPopover.vue?vue&type=script&lang=js"
export * from "./FeedbackPopover.vue?vue&type=script&lang=js"

import "./FeedbackPopover.vue?vue&type=style&index=0&id=5a34bcb7&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a34bcb7"]])

export default __exports__